<template>
  <div class="screen screen__settings">
    <el-container direction="horizontal">
      <div class="background-fixed">
        <div class="co-brand" v-if="coBrandLogoUrl">
          <img :src="coBrandLogoUrl" />
        </div>
      </div>
      <el-aside class="sidebar" v-if="!working">
        <el-container direction="vertical" class="page--container">

          <section class="page--section">
            <h2 class="section__title">{{ $t('accountSettingsInfoHeadline') }}</h2>
            <user-info></user-info>
          </section>

          <section v-if="supportedFeaturesOfflineMode" class="page--section" v-loading="downloadLoading">
            <h2 class="section__title">{{ $t('accountSettingsOfflineTitle') }}</h2>
            <p>{{ $t('accountSettingsOfflineDescriptionIntro1') }}</p>
            <p>{{ $t('accountSettingsOfflineDescriptionIntro2') }}</p>
            <ul>
              <li>{{ $t('accountSettingsOfflineDescriptionList1') }}</li>
              <li>{{ $t('accountSettingsOfflineDescriptionList2') }}</li>
              <li>{{ $t('accountSettingsOfflineDescriptionList3') }}</li>
              <li>{{ $t('accountSettingsOfflineDescriptionList4') }}</li>
              <li>{{ $t('accountSettingsOfflineDescriptionList5') }}</li>
              <ul>
                <li>{{ $t('accountSettingsOfflineDescriptionList6') }}</li>
                <li>{{ $t('accountSettingsOfflineDescriptionList7') }}</li>
              </ul>
            </ul>
            <offline-setting />
          </section>
          <section v-else>
            <!-- <h2 class="section__title">{{ $t('accountSettingsOfflineTitle') }}</h2>
            <p>{{ $t('accountSettingsOfflineUnavailable') }}</p> -->
          </section>

          <user-activity v-if="approved" />
        </el-container>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import user from '@/components/user';
import offline from '@/offline';
import authentication from '@/authentication';
import UserInfo from '@/components/user/UserInfo.vue';
import UserActivity from '@/components/activity/UserActivity';
import OfflineSetting from '@/components/OfflineSetting';
import mixins from '@/mixins';


export default {
  name: 'Settings',
  mixins: [
    mixins.supportedFeatures
  ],
  computed: {
    ...mapState(offline.downloadStore.namespace, [
      'downloadLoading'
    ]),
    ...mapState(user.store.namespace, [
      'currentUser'
    ]),
    ...mapState(authentication.store.namespace, [
      'working'
    ]),
    ...mapGetters(user.store.namespace, [
      'region'
    ]),
    approved() {
      return 'approved' in this.currentUser && this.currentUser.approved
    },
    coBrandLogoUrl() {
      return this.region && this.region.logo && this.region.logo.url;
    }
  },
  components: {
    UserInfo,
    UserActivity,
    OfflineSetting
  }
}
</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';

.screen {

  &__settings {
    height: 100%;
  }
}

.background-fixed {
  display: none;
  background: url("@/assets/images/settings-background.jpg") no-repeat left center;
  background-size: auto cover;
  box-shadow: 0 0 0 20px rgba(0, 0, 0, .8);

  @include res(md) {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    overflow: auto;
    width: 100%;
    height: 100%;
  }
}

.co-brand {
  position: absolute;
  top: 0;
  left: 0;
  overflow: auto;
  width: 33% !important;
  height: 100%;
  background: rgba(255, 255, 255, .75);
  display: none;

  @include res(md) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    object-fit: contain;
    max-width: 80%;
    max-height: 80%;
  }
}

.sidebar {
  position: absolute;
  top: 0;
  right: 0;
  overflow: auto;
  height: 100%;
  width: 100% !important;
  background: #fafafa;

  @include res(md) {
    width: 67% !important;
  }
}

.page--container {
  margin: 0 10px !important;

  @include res(md) {
    margin: 0 40px !important;
  }
}
</style>
